package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.StudioService
import br.com.heyagenda.domain.repository.ServiceRepository

class SaveServiceUseCase(
    private val repository: ServiceRepository
) {
    suspend operator fun invoke(service: StudioService): Result<Unit> {
        if (service.name.isBlank()) {
            return Result.failure(IllegalArgumentException("O nome do serviço é obrigatório."))
        }
        if (service.priceFormatted.isBlank()) {
            return Result.failure(IllegalArgumentException("O valor do serviço é obrigatório."))
        }
        return repository.saveService(service)
    }
}
